
import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';

const container = document.getElementById('root');

// 👇 basename: '/' for snap, '/templates/business-services' in real life
const isSnap = typeof navigator !== 'undefined' && navigator.userAgent === 'react-snap';
const basename = isSnap ? '/' : '/templates/handyman/';

const app = (
  <HelmetProvider>
    <BrowserRouter basename={basename}>
      <App />
    </BrowserRouter>
  </HelmetProvider>
);

if (container.hasChildNodes()) {
  hydrateRoot(container, app);
} else {
  createRoot(container).render(app);
}
